export default "__VITE_ASSET__BH82YMVu__"